import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import PropTypes from 'prop-types';
import cn from 'classnames';
import './BrandOnboardingReviewPanel.scss';

import { updateBrandOnboardingObject } from '../../../Actions/OnboardingActions';

import BrandOnboardingProgressBar from '../BrandOnboardingProgressBar';

const BrandOnboardingReviewPanel = props => {
  return (
    <div className='brand-onboarding-review-panel-outer'>
      <div className='brand-onboarding-review-panel-inner'>
        <div className='brand-onboarding-split-container-outer'>
          <div className='brand-onboarding-split-container-inner'>
            <div className='brand-onboarding-graphic-container-outer'>
              <div className='brand-onboarding-graphic-container-inner'>
                <BrandOnboardingProgressBar
                  goToPanel={props.goToPanel}
                  sections={props.sections}
                  activeSectionName={props.activeSectionName}
                  activePanelName={props.activePanelName}
                />
              </div>

              <div className='brand-onboarding-graphic-background'>
                <img className='brand-onboarding-graphic-background-image' src={props.backgroundImage} alt='name panel graphic' />
                <div className='brand-onboarding-graphic-background-overlay'></div>
              </div>
            </div>

            <div className='brand-onboarding-input-container-outer'>
              <div className='brand-onboarding-input-container-number-marker'>{props.panelNumber}</div>

              <div className={cn('brand-onboarding-input-container-inner', { isLoading: props.isLoading })}>
                <div className='brand-onboarding-title-text'>Review Information</div>
                <div className='brand-onboarding-subtitle-text'>Take a moment to see if all your information is correct.</div>

                <div className='brand-onboarding-review-panel-sections'></div>

                <div className='brand-onboarding-pagination-buttons'>
                  <button className='brand-onboarding-button stretch' onClick={() => props.goToPreviousPanel()}>
                    Back
                  </button>
                  <button className='brand-onboarding-button stretch primary' onClick={() => props.goToNextPanel()}>
                    Next
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

BrandOnboardingReviewPanel.propTypes = {
  onboarding: PropTypes.object.isRequired,
  updateBrandOnboardingObject: PropTypes.func.isRequired,

  panels: PropTypes.array.isRequired,
  goToPreviousPanel: PropTypes.func.isRequired,
  goToNextPanel: PropTypes.func.isRequired,
  goToPanel: PropTypes.func.isRequired
};

const mapStateToProps = state => {
  const { onboarding } = state;
  return { onboarding };
};

export default connect(mapStateToProps, {
  updateBrandOnboardingObject
})(withRouter(BrandOnboardingReviewPanel));
